import { Component, OnInit } from '@angular/core';
import { AppState, FormItem } from '../../models/app-state';
import { AppFlowService } from '../../services/app-flow.service';
import { Router } from '@angular/router';
import { reduce } from 'lodash';
import { SessionStorageService } from '../../services/session-storage.service';
import { EnvConfig } from '../../models/env-config';

@Component({
  selector: 'app-application-sent',
  templateUrl: './application-sent-page.component.html',
  styleUrls: ['./application-sent-page.component.scss'],
})
export class ApplicationSentPageComponent implements OnInit {
  phoneNumber = '(99) 99999-9999';
  name = 'NOME';
  envConfig: EnvConfig;
  messageTitle: string = '';
  messageBody: string = '';
  messageFooter: string = '';

  interpolateText(text: string, key: string, value: string): string {
    return text.replace(`{{${key}}}`, value);
  }

  constructor(
    private sessionStorageService: SessionStorageService,
    private appFlowService: AppFlowService,
    private router: Router
  ) {
    this.envConfig = sessionStorageService.getEnvConfig();
  }

  ngOnInit(): void {
    this.messageTitle = this.envConfig['message.sent.title'] || '';
    this.messageBody = this.envConfig['message.sent.body']|| '';
    this.messageFooter = this.envConfig['message.sent.footer'] || '';
  }
}
